module.exports = __webpack_public_path__ + "static/media/pierwszy_widok_bckgrnd.0b5d66e4.svg";